import {
  akshatKharbandaImage,
  ankeshKehmaniImage,
  anshulSadariaImage,
  dushyantPathakImage,
  ishanGuptaImage,
  khusbuGuptaImage,
  kushalVijayImage,
  shashankMishraImage,
  siddhartDashImage,
  souravMohantyImage,
  sujeetSinghImage,
  vaisnaviDwivediImage
} from '../assets/images'

export const past_events = [
  {
    eventName: 'How to get started with Hackathons',
    speaker: 'Ishan Gupta, Almabase',
    image: ishanGuptaImage.src
  },
  {
    eventName: 'All You Need to know about Big Data',
    speaker: 'Shashank Mishrta, E-Learning Bridge',
    image: shashankMishraImage.src
  },
  {
    eventName: 'Importance of Leadership and Peoples Skills in Tech Jobs',
    speaker: 'Siddharth Dash,S&OP Amazon Luxembourg',
    image: siddhartDashImage.src
  },
  {
    eventName: 'The roadmap for becoming a successful freelancer',
    speaker: 'Kushal Vijay,Back-end Intern @PhantomStack',
    image: kushalVijayImage.src
  },
  {
    eventName: 'Time Managment 101 for students',
    speaker: 'Vaishnavi Dwivedi, Product & UX @Bottle',
    image: vaisnaviDwivediImage.src
  },
  {
    eventName: 'How to prepare for FAANG companies?',
    speaker: 'Aanshul Sadaria, SWE II@Google',
    image: anshulSadariaImage.src
  },
  {
    eventName: 'Interview and AMA Session of a Software Engineer',
    speaker: 'Sourav Mohanty, SWE Abillion',
    image: souravMohantyImage.src
  },
  {
    eventName: 'All the advantages of Competitive Coding',
    speaker: 'Khushbu Gupta, SDE-2@TSYS',
    image: khusbuGuptaImage.src
  },
  {
    eventName: 'Importance of Open Source and How to get staryed with it',
    speaker: 'Dushyant Pathak, SDE Intern@Crio.Do',
    image: dushyantPathakImage.src
  },
  {
    eventName: 'How to Get started as a fresher in AI / ML',
    speaker: 'Ankesh Khemani, AI/ML Engineer at Atlassian',
    image: ankeshKehmaniImage.src
  },
  {
    eventName: 'Tips for building confidence for building a startup',
    speaker: 'Sujeet Singh, Founder @TheButterApp',
    image: sujeetSinghImage.src
  },
  {
    eventName: 'How to Kick start your Data Science Journey',
    speaker: 'Akshat Kharbanda, Data Scientist',
    image: akshatKharbandaImage.src
  }
]
